import React from 'react';

import { FlexContainer, Image, Title } from '../common/StyledComponents';

import bgtop from '../../assets/bg-top.png';
import bgbottom from '../../assets/bg-bottom.png';
import getStarted from '../../assets/get-started.png';

import one from '../../assets/1.png';
import two from '../../assets/2.png';
import three from '../../assets/3.png';
import four from '../../assets/4.png';

import fb from '../../assets/facebook-shadow.png';
import ig from '../../assets/insta-shadow.png';
import yt from '../../assets/youtube-shadow.png';
import tt from '../../assets/twitter-shadow.png';

import ContactForm from '../common/Forms/ContactForm';
import OurPartners from './OurPartners';

const bgTop = `url(${bgtop})`;
const bgBottom = `url(${bgbottom})`;

const Advertise = () => {
  window.scrollTo(0, 0);

  return (
    <div>
      <FlexContainer
        className="justify-center items-center"
        style={{
          height: 'calc(100vh - 70px)',
          width: '100vw',
          backgroundSize: 'cover',
          backgroundAttachment: 'fixed'
        }}
        background={bgTop}
      >
        <FlexContainer className="pv2 ph4 h-100" style={{ maxHeight: '50vh' }}>
          <FlexContainer className="h-100">
            <FlexContainer
              className="flex-column h-100 ph3 pv5"
              maxwidth="950px"
            >
              <Title
                // className="pa3 pa4-m pa5-l"
                className=""
                fontFamily="Montserrat"
                // fontWeight="bold"
                // fontstyle="italic"
                fontSize="3.375rem"
                color="#fff"
              >
                Don’t get Stuck In the
              </Title>
              <Title
                // className="pa3 pa4-m pa5-l"
                className=""
                fontFamily="Montserrat"
                fontWeight="bold"
                // fontstyle="italic"
                fontSize="3.375rem"
                color="#4db2ec"
              >
                Crowd
              </Title>
              <Title
                className=""
                fontFamily="Montserrat"
                // fontWeight="bold"
                fontSize="3.375rem"
                lineHeight="1.25"
                color="#fff"
              >
                Get
                <b> Heard</b> With <b>India’s</b>{' '}
                <i>
                  <b>Biggest</b> Tech Media
                </i>
              </Title>
            </FlexContainer>
          </FlexContainer>
          <FlexContainer className="items-center mb6-ns">
            <img
              src={getStarted}
              alt="get-started"
              width="217px"
              height="142px"
            />
          </FlexContainer>
        </FlexContainer>
      </FlexContainer>

      <FlexContainer className="justify-center bg-white">
        <FlexContainer className="w-100 flex-column" maxwidth="950px">
          <FlexContainer className="convince w-100 mt5-ns mt3 mb4 flex-column">
            <Title
              fontFamily="Nunito"
              fontSize="3rem"
              fontWeight="bold"
              color="#484848"
            >
              Why Advertise on Beebom?
            </Title>
            <FlexContainer className="flex-wrap mt5">
              <FlexContainer className="flex-column justify-center items-center w-50-ns w-100 mb5">
                <Image src={one} alt="one" width="60px" height="59px" />
                <Title
                  className="tc mt3"
                  fontFamily="Montserrat"
                  fontSize="1.125rem"
                  color="#484848"
                  style={{ width: '263px' }}
                >
                  Reach your Target Audience and focused group with Beebom.
                </Title>
              </FlexContainer>
              <FlexContainer className="flex-column justify-center items-center w-50-ns w-100 mb5">
                <Image src={two} alt="one" width="68px" height="53px" />
                <Title
                  className="tc mt3"
                  fontFamily="Montserrat"
                  fontSize="1.125rem"
                  color="#484848"
                  style={{ width: '263px' }}
                >
                  We create REAL intent - driving real results for your
                  business.
                </Title>
              </FlexContainer>
              <FlexContainer className="flex-column justify-center items-center w-50-ns w-100">
                <Image src={three} alt="one" width="30px" height="46px" />
                <Title
                  className="tc mt3"
                  fontFamily="Montserrat"
                  fontSize="1.125rem"
                  color="#484848"
                  style={{ width: '263px' }}
                >
                  We use the strength of our brand to get your audience leaned
                  into your content and act on it.
                </Title>
              </FlexContainer>
              <FlexContainer className="flex-column justify-center items-center w-50-ns w-100">
                <Image src={four} alt="one" width="43px" height="50px" />
                <Title
                  className="tc mt3"
                  fontFamily="Montserrat"
                  fontSize="1.125rem"
                  color="#484848"
                  style={{ width: '263px' }}
                >
                  Increase your footfall and drive mire revenue by boosting the
                  visiblity of product
                </Title>
              </FlexContainer>
            </FlexContainer>
          </FlexContainer>

          <FlexContainer className="media-stats w-100 mt5-ns mt3 mb5-ns mb3 flex-column">
            <Title
              fontFamily="Montserrat"
              fontSize="3rem"
              fontWeight="bold"
              color="#000"
            >
              Our Media Stats
            </Title>
            <FlexContainer className="flex-wrap mt5 justify-center items-start">
              <FlexContainer className="flex-column justify-center items-center w-third-ns w-100">
                <Image src={one} alt="one" width="60px" height="59px" />
                <Title
                  className="tc mt4 b"
                  fontFamily="Montserrat"
                  fontSize="3rem"
                  color="#212121"
                  style={{ width: '263px' }}
                >
                  40M
                </Title>
                <Title
                  className="tc mt2"
                  fontFamily="Montserrat"
                  fontSize="1.5rem"
                  color="#212121"
                  style={{ width: '263px' }}
                >
                  Total Impressions
                </Title>
              </FlexContainer>
              <FlexContainer className="flex-column justify-center items-center w-third-ns w-100 mt5 mt0-ns">
                <Image src={one} alt="one" width="60px" height="59px" />
                <Title
                  className="tc mt4 b"
                  fontFamily="Montserrat"
                  fontSize="3rem"
                  color="#212121"
                  style={{ width: '263px' }}
                >
                  8.7M
                </Title>
                <Title
                  className="tc mt2"
                  fontFamily="Montserrat"
                  fontSize="1.5rem"
                  color="#212121"
                  style={{ width: '263px' }}
                >
                  Total Video Views
                </Title>
              </FlexContainer>
              <FlexContainer className="flex-column justify-center items-center w-third-ns w-100 mt5 mt0-ns">
                <Image src={one} alt="one" width="60px" height="59px" />
                <Title
                  className="tc mt4 b"
                  fontFamily="Montserrat"
                  fontSize="3rem"
                  color="#212121"
                  style={{ width: '263px' }}
                >
                  33.5M
                </Title>
                <Title
                  className="tc mt2"
                  fontFamily="Montserrat"
                  fontSize="1.5rem"
                  color="#212121"
                  style={{ width: '263px' }}
                >
                  Total Social Media Reach
                </Title>
              </FlexContainer>
            </FlexContainer>
          </FlexContainer>
        </FlexContainer>
      </FlexContainer>

      <FlexContainer className="justify-center" background="#f3f4f6">
        <FlexContainer className="w-100 flex-column" maxwidth="950px">
          <FlexContainer className="convince w-100 mt5-ns mt3 flex-column">
            <FlexContainer className="flex-wrap justify-between">
              <FlexContainer className="flex-column w-25 items-center">
                <Image src={fb} alt="one" width="137px" height="137px" />
                <Title
                  fontFamily="Nunito"
                  fontSize="1.2rem"
                  // fontWeight="bold"
                  color="#484848"
                >
                  1 Million Likes
                </Title>
                <Title
                  className="mt3"
                  fontFamily="Nunito"
                  fontSize="1.2rem"
                  // fontWeight="bold"
                  color="#484848"
                >
                  5 Million Video Views
                </Title>
              </FlexContainer>
              <FlexContainer className="flex-column w-25 items-center">
                <Image src={tt} alt="one" width="137px" height="137px" />
                <Title
                  fontFamily="Nunito"
                  fontSize="1.2rem"
                  // fontWeight="bold"
                  color="#484848"
                >
                  100K Followers
                </Title>
                {/* <Title
                className="mt3"
                  fontFamily="Nunito"
                  fontSize="1.2rem"
                  // fontWeight="bold"
                  color="#484848"
                >
                  5 Million Video Views
                </Title> */}
              </FlexContainer>
              <FlexContainer className="flex-column w-25 items-center">
                <Image src={ig} alt="one" width="137px" height="137px" />
                <Title
                  fontFamily="Nunito"
                  fontSize="1.2rem"
                  // fontWeight="bold"
                  color="#484848"
                >
                  150K Followers
                </Title>
                {/* <Title
                  className="mt3"
                  fontFamily="Nunito"
                  fontSize="1.2rem"
                  // fontWeight="bold"
                  color="#484848"
                >
                  5 Million Video Views
                </Title> */}
              </FlexContainer>
              <FlexContainer className="flex-column w-25 items-center">
                <Image src={yt} alt="one" width="137px" height="137px" />
                <Title
                  fontFamily="Nunito"
                  fontSize="1.2rem"
                  // fontWeight="bold"
                  color="#484848"
                >
                  1 Million Subscribers
                </Title>
                <Title
                  className="mt3"
                  fontFamily="Nunito"
                  fontSize="1.2rem"
                  // fontWeight="bold"
                  color="#484848"
                >
                  5 Million Video Views
                </Title>
              </FlexContainer>
            </FlexContainer>
            {/* <FlexContainer className="justify-between mt4 mh3"> */}
            {/* <FlexContainer className="flex-column">
                <Title
                  fontFamily="Montserrat"
                  fontSize="1.5rem"
                  fontWeight="bold"
                  color="#484848"
                >
                  1 Million Likes
                </Title>
              </FlexContainer> */}
            {/* <Title
                className="underline flex items-end"
                fontFamily="Montserrat"
                fontSize="1.5rem"
                color="#4db2ec"
              >
                Go to our Page
              </Title> */}
            {/* </FlexContainer> */}
          </FlexContainer>

          <FlexContainer className="media-stats w-100 mt5-ns mt3 mb5-ns mb3 flex-column">
            <FlexContainer className="flex-wrap mt5 justify-center items-start">
              <FlexContainer className="flex-column justify-center items-center w-third-ns w-100">
                <Image src={one} alt="one" width="60px" height="59px" />
                <Title
                  className="tc mt4 b"
                  fontFamily="Montserrat"
                  fontSize="3rem"
                  color="#212121"
                  style={{ width: '263px' }}
                >
                  100K
                </Title>
                <Title
                  className="tc mt2"
                  fontFamily="Montserrat"
                  fontSize="1.5rem"
                  color="#212121"
                  style={{ width: '263px' }}
                >
                  App Downloads
                </Title>
              </FlexContainer>
              <FlexContainer className="flex-column justify-center items-center w-third-ns w-100 mt5 mt0-ns">
                <Image src={one} alt="one" width="60px" height="59px" />
                <Title
                  className="tc mt4 b"
                  fontFamily="Montserrat"
                  fontSize="3rem"
                  color="#212121"
                  style={{ width: '263px' }}
                >
                  2M
                </Title>
                <Title
                  className="tc mt2"
                  fontFamily="Montserrat"
                  fontSize="1.5rem"
                  color="#212121"
                  style={{ width: '263px' }}
                >
                  Website Reach
                </Title>
              </FlexContainer>
              <FlexContainer className="flex-column justify-center items-center w-third-ns w-100 mt5 mt0-ns">
                <Image src={one} alt="one" width="60px" height="59px" />
                <Title
                  className="tc mt4 b"
                  fontFamily="Montserrat"
                  fontSize="3rem"
                  color="#212121"
                  style={{ width: '263px' }}
                >
                  50K
                </Title>
                <Title
                  className="tc mt2"
                  fontFamily="Montserrat"
                  fontSize="1.5rem"
                  color="#212121"
                  style={{ width: '263px' }}
                >
                  Daily Website Users
                </Title>
              </FlexContainer>
            </FlexContainer>
          </FlexContainer>
        </FlexContainer>
      </FlexContainer>

      <FlexContainer className="justify-center bg-white">
        <FlexContainer className="flex-column mt4-ns mt3" maxwidth="950px">
          <Title
            className="tc b"
            fontFamily="Nunito"
            fontSize="3rem"
            color="#5a5a5a"
          >
            Our Partners
          </Title>
          <OurPartners />
        </FlexContainer>
      </FlexContainer>

      <FlexContainer
        className="justify-center items-center"
        style={{
          // height: 'calc(100vh - 70px - 5px - 186px)',
          minHeight: '60vh',
          width: '100vw',
          backgroundSize: 'cover'
        }}
        background={bgBottom}
      >
        <FlexContainer
          className="flex-column w-100 pv2 ph4 mv4"
          maxwidth="950px"
        >
          <Title
            // className="pa3 pa4-m pa5-l"
            className="mb3"
            fontFamily="Montserrat"
            fontWeight="bold"
            fontSize="2.25rem"
            color="#323232"
            style={{
              width: '100vw',
              maxWidth: '550px'
            }}
          >
            Reach your Audience with Beebom
          </Title>
          <Title
            className="mb4"
            fontFamily="Nunito"
            fontWeight="bold"
            fontSize="1.5rem"
            color="#323232"
          >
            Lets get started
          </Title>
          <ContactForm full />
        </FlexContainer>
      </FlexContainer>

      {/* <FlexContainer
        className="w-100"
        style={{ height: '5px', background: '#4db2ec' }}
      /> */}
    </div>
  );
};

export default Advertise;
